import { useFormContext, UseFormReturn } from 'react-hook-form';

import { AppError } from '@/utils';

import { UserProfileForm } from './use-user-profile.form';

export const useUserProfileFormContext = ():
  | UseFormReturn<UserProfileForm>
  | never => {
  const form = useFormContext<UserProfileForm>();

  if (form === null)
    throw AppError.hookScopeError('useUserProfileFormContext error.');

  return form;
};
